import React from 'react';
import { Loader2 } from 'lucide-react';
import StandardModal from './StandardModal';
import InfoCard from './InfoCard';
import { SecondaryButton, DangerButton } from './Buttons';

/**
 * DeleteConfirmModal — the ONE reusable destructive-confirmation modal
 * used everywhere (Roles, Team, bulk deletes, …). Same shell, same buttons,
 * same warning treatment, so every delete feels identical.
 *
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {() => void} onConfirm
 * @param {string} title
 * @param {string} [description]
 * @param {boolean} [isDeleting]
 * @param {string} [confirmLabel]
 * @param {React.ReactNode} [children]   custom warning body (defaults provided)
 */
const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  isDeleting = false,
  confirmLabel = 'Delete',
  children,
}) => (
  <StandardModal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    description={description}
    size="sm"
    footer={
      <>
        <SecondaryButton onClick={onClose} className="flex-1" disabled={isDeleting} data-testid="delete-cancel-button">
          Cancel
        </SecondaryButton>
        <DangerButton onClick={onConfirm} className="flex-1" disabled={isDeleting} data-testid="delete-confirm-button">
          {isDeleting ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Deleting...
            </>
          ) : (
            confirmLabel
          )}
        </DangerButton>
      </>
    }
  >
    <InfoCard variant="danger" showIcon={true}>
      {children || (
        <>
          <p className="font-medium mb-1">This action cannot be undone.</p>
          <p>This item will be permanently removed.</p>
        </>
      )}
    </InfoCard>
  </StandardModal>
);

export default DeleteConfirmModal;
